import React, { ReactElement } from 'react';
import { NavigateFunction } from 'react-router-dom';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';
import TextAvatar from '@components/common/TextAvatar';

import { dateFormattingWithSlash } from '@utils/date';

import { routes } from '@constants/routes';

import styles from '../AssetRentRequests/AssetRentRequests.module.scss';

const {
	adminPanel: {
		index,
		outgoingRequestsPath,
	},
} = routes;

const getOutgoingRequestsColumns = (navigate: NavigateFunction): any[] => {
	const handleView = (id?: string) => () => {
		if (!id) return;

		navigate(`${index}${outgoingRequestsPath}/${id}`);
	};

	return (
		[
			{
				header: 'Request ID',
				accessorKey: 'requestId',
				enableSorting: false,
				isStickyLeft: true,
				cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
					const value = getValue();

					return (
						<AdaptiveTableCell
							onDoubleClick={handleView(row.original.id)}
							text={value}
						/>
					);
				},
			},
			{
				header: 'Asset Owner',
				accessorKey: 'assetOwner.name',
				enableSorting: false,
				isStickyLeft: true,
				cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
					const value = getValue();

					return (
						<div
							className={styles.assetOwnerName}
							onDoubleClick={handleView(row.original.id)}
						>
							<TextAvatar
								avatarId={row.original?.assetOwner?.avatar?.id}
								fontSize='10px'
								fontWeight={400}
								fullName={row?.original?.assetOwner?.name}
								id={row?.original?.assetOwner?.id}
								isProfileLogo
								size='30px'
							/>
							<AdaptiveTableCell text={value} />
						</div>
					);
				},
			},
			{
				header: 'Asset quantity',
				accessorKey: 'assetQuantity',
				enableSorting: false,
				isStickyLeft: true,
				cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
					const value = getValue();

					return (
						<AdaptiveTableCell
							onDoubleClick={handleView(row.original.id)}
							text={value}
						/>
					);
				},
			},
			{
				header: 'Request date',
				accessorKey: 'createdAt',
				cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
					const value = getValue();

					return (
						<AdaptiveTableCell
							onDoubleClick={handleView(row.original.id)}
							text={dateFormattingWithSlash(value)}
						/>
					);
				},
			},
			{
				header: 'Request Status',
				accessorKey: 'requestStatus.title',
				cell: ({ getValue, row }: CellContext<any, any>): ReactElement => {
					const value = getValue();

					return (
						<AdaptiveTableCell
							onDoubleClick={handleView(row.original.id)}
							text={value}
						/>
					);
				},
			},
			{
				header: () => <div className={styles.actionsHeaderColumn}><span>Actions</span></div>,
				accessorKey: 'actions',
				enableSorting: false,
				cell: ({ row }: CellContext<any, any>): ReactElement => {
					return (
						<Actions
							gridNumberOfColumns={1}
							isView
							viewHandler={handleView(row.original.id)}
							viewTooltip='View request card'
						/>
					);
				},
			},
		]
	);
};

export default getOutgoingRequestsColumns;
